import React from 'react';
import { Path } from 'react-konva';

const DefaultMineIcon = (props) => {
	const theme = props?.theme ?? 'light';
	const size_portion = props?.size_portion ?? 25;
	const path_scale = props?.path_scale ?? 1;
	const x = props?.x ?? 0;
	const y = props?.y ?? 0;
	const init_x = props?.init_x ?? 0;
	const init_y = props?.init_y ?? 0;

	const size_portion_multiplier = size_portion * 0.06;

	return (
		<>
			<Path
				fill={(theme == 'light') ? 'black' : 'white'}
				data="M21.66,13.61c0.04-0.33,0.06-0.66,0.06-1c0-0.34-0.02-0.67-0.06-1h-1.52c-0.09-0.65-0.25-1.27-0.49-1.85l1.31-0.76c-0.27-0.62-0.61-1.19-1.01-1.73l-1.31,0.76c-0.39-0.51-0.84-0.96-1.35-1.35l0.76-1.31c-0.54-0.4-1.11-0.74-1.73-1.01l-0.76,1.31c-0.58-0.24-1.2-0.4-1.85-0.49V3.67c-0.33-0.04-0.66-0.06-1-0.06s-0.67,0.02-1,0.06v1.52c-0.65,0.09-1.27,0.25-1.85,0.49L9.11,4.37C8.49,4.64,7.92,4.98,7.38,5.38l0.76,1.31C7.63,7.08,7.18,7.53,6.79,8.04L5.48,7.28c-0.4,0.54-0.74,1.11-1.01,1.73l1.31,0.76c-0.24,0.58-0.4,1.2-0.49,1.85H3.77c-0.04,0.33-0.06,0.66-0.06,1c0,0.34,0.02,0.67,0.06,1h1.52c0.09,0.65,0.25,1.27,0.49,1.85l-1.31,0.76c0.27,0.62,0.61,1.19,1.01,1.73l1.31-0.76c0.39,0.51,0.84,0.96,1.35,1.35l-0.76,1.31c0.54,0.4,1.11,0.74,1.73,1.01l0.76-1.31c0.58,0.24,1.2,0.4,1.85,0.49v1.52c0.33,0.04,0.66,0.06,1,0.06s0.67-0.02,1-0.06v-1.52c0.65-0.09,1.27-0.25,1.85-0.49l0.76,1.31c0.62-0.27,1.19-0.61,1.73-1.01l-0.76-1.31c0.51-0.39,0.96-0.84,1.35-1.35l1.31,0.76c0.4-0.54,0.74-1.11,1.01-1.73l-1.31-0.76c0.24-0.58,0.4-1.2,0.49-1.85H21.66z"
				width={size_portion}
				height={size_portion}
				pos_x={x}
				pos_y={y}
				x={init_x + size_portion_multiplier}
				y={init_y + size_portion_multiplier}
				scaleX={path_scale}
				scaleY={path_scale}
			/>

			<Path
				data="M12.5,7c-2.04,0-3.81,1.11-4.76,2.75"
				width={size_portion}
				height={size_portion}
				pos_x={x}
				pos_y={y}
				x={init_x + size_portion_multiplier}
				y={init_y + size_portion_multiplier}
				stroke="gray"
				strokeWidth={1}
				scaleX={path_scale}
				scaleY={path_scale}
				lineCap="round"
				lineJoin="round"
			/>
		</>
	)
}

export default DefaultMineIcon;